<template>
  <div class="register-area">
    <loader v-show="isFormLoading"></loader>
    <div v-show="!isFormLoading">
      <error :errors="errors"></error>
      <b-form @submit="onSubmit" enctype="multipart/form-data">
        <div class="pep-section">
          <div>
            <b-form-group>
              <div>{{ $t('companyprofile.toBeCompliant') }}</div>
            </b-form-group>
            <b-form-group>{{ $t('companyprofile.companyActivityType') }}<div>
                <b-form-checkbox-group
                    id="activity_types"
                    v-model="form.activity_type"
                    :options="this.translate(activity_options)"
                    name="activity_type"
                    ref="activity_type"
                    stacked
                ></b-form-checkbox-group>
                <div class="mt-3" v-if="form.activity_type.indexOf($t('classificators.companyActivity.other')) !== -1">
                  <b-form-input v-model="form.other_activity_type" required :placeholder="$t('companyprofile.enterActivityType')" :formatter="onlyLatinFormatter"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <b-form-group>{{ $t('companyprofile.primarySourceOf') }}<div>
                <b-form-radio v-model="form.primary_source" name="primary_source" value="Active" required>{{$t(primary_source_options[0].text)}}</b-form-radio>
                <b-form-radio v-model="form.primary_source" name="primary_source" value="Passive">{{$t(primary_source_options[1].text)}}</b-form-radio>
              </div>
            </b-form-group>
            <div>
              <b-form-group>{{ $t('companyprofile.originOfFunds') }}
                <help-tooltip tooltipText="companyprofile.originOfFundsTooltip"></help-tooltip>
                <b-form-input v-model="form.origin" required :placeholder="$t('companyprofile.enterOriginOfFunds')" :formatter="onlyLatinFormatter"></b-form-input>
              </b-form-group>
            </div>
            <div>
              <b-form-group>{{ $t('companyprofile.turnoverLast_Months') }}<b-form-select v-model="form.turnover" :options="this.translate(turnover_options)" required></b-form-select>
              </b-form-group>
            </div>
            <div>
              <b-form-group>{{ $t('companyprofile.theUltimateBeneficial') }}<help-tooltip
                  tooltipText="companyprofile.theUltimateBeneficialTooltip"></help-tooltip>
                <b-form-radio-group id="radio-group-actual-beneficiary" v-model="actual_beneficiary" name="radio-actual-beneficiary-component" required>
                  <b-form-radio name="actual_beneficiary" value="true">{{ $t('companyprofile.yes') }}</b-form-radio>
                  <b-form-radio name="actual_beneficiary" value="false">{{ $t('investorprofile.no') }}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div v-if="actual_beneficiary==='false'">
              <div v-for="(bo, index) in bos" v-bind:key="index">
                <div v-if="bo">
                  <div>{{ $t('companyprofile.beneficialOwnerDetails') }}</div>
                  <div class="inline-group">
                    <b-form-group class="w-50 first-inline-field">
                      <b-form-input v-model="form.beneficial_owners[index].first_name" required :placeholder="$t('companyprofile.enterFirstName')" :formatter="onlyLatinFormatter">{{ $t('companyprofile.firstName') }}</b-form-input>
                    </b-form-group>
                    <b-form-group class="w-50 last-inline-field">
                      <b-form-input v-model="form.beneficial_owners[index].last_name" required :placeholder="$t('companyprofile.enterLastName')" :formatter="onlyLatinFormatter">{{ $t('companyprofile.lastName') }}</b-form-input>
                    </b-form-group>
                  </div>
                  <b-form-group>{{ $t('companyprofile.dateOfBirth') }}<b-form-datepicker v-model="form.beneficial_owners[index].dob"
                                       :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                       :date-disabled-fn="dateDisabled"
                                       required
                                       locale="en">
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group class="form-group" v-if="citizenshipItems">{{ $t('companyprofile.citizenship') }}<cool-select
                        required
                        v-model="form.beneficial_owners[index].citizenship"
                        :items="citizenshipItems"
                        :placeholder="form.beneficial_owners[index].citizenship ? '' : $t('app.selectCountry')"
                        item-value="short_name"
                        :item-text="$t('companyprofile.name')"
                        aria-required="true"
                        ref="citizenship"
                        class="country-select form-field"
                        :class="submitted && !form.beneficial_owners[index].citizenship? ' form-control is-invalid': ''"
                    >
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: country }">
                        <div style="display: flex; align-items: center;">
                          <img v-if="country.short_name" :src="getFlag(country.short_name)" class="country-flag">

                          <div>
                            <b>{{ country.name }}</b>
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: country }">
                        <img v-if="country.short_name" :src="getFlag(country.short_name)" class="country-flag">
                        <div>
                          <b>{{ country.name }}</b>
                        </div>
                      </template>
                    </cool-select>
                  </b-form-group>
                  <b-form-group class="text-right">
                    <b-button @click="removeUboPerson(index)">{{ $t('companyprofile.removeUboPerson') }}</b-button>
                  </b-form-group>
                </div>
              </div>
              <div>
                <b-button v-if="newUbo<4" @click="addAnotherUbo">{{ $t('companyprofile.addAnotherUbo') }}</b-button>
              </div>
            </div>
            <div class="note">{{ $t('companyprofile.pleaseNoteThat') }}</div>
            <b-form-group>{{ $t('companyprofile.theWayPower') }}<div>
                <b-form-radio-group
                    id="checkbox-group-2"
                    v-model="form.way_power_type"
                    :options="this.translate(way_power_options)"
                    name="way_power_type"
                    stacked
                    required
                ></b-form-radio-group>
                <div class="mt-3" v-if="form.way_power_type.indexOf($t('classificators.companyWayPowerIsExercised.other')) !== -1">
                  <b-form-input v-model="form.other_way_power_type" required :placeholder="$t('companyprofile.pleaseIndicate')" :formatter="onlyLatinFormatter"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox name="agreement" v-model="form.control_another_person" class="another_person_component">
                {{$t('companyprofile.pleaseTickThis')}}
              </b-form-checkbox>
              <div v-if="form.control_another_person === true">
                <div class="note">
                  {{$t('companyprofile.ifControlIsExercised')}}
                </div>
              </div>
            </b-form-group>
            <div class="according">{{ $t('companyprofile.areYouOne') }}<img alt="" class="help" id="pep_help" v-bind:src="getSrc('help.svg')" @click="pep_help = !pep_help"/>
              <b-alert v-model="pep_help" variant="info" dismissible>
                <div>{{ $t('companyprofile.politicallyExposedPersonsPeps') }}</div>
                <br/>
                <div><strong>{{ $t('companyprofile.aPoliticallyExposedPerson') }}</strong>{{ $t('companyprofile.isANatural') }}</div>
                <br/>
                <div><strong>{{ $t('companyprofile.immediateFamilyMembersInclude') }}</strong>:</div>
                <div>{{ $t('companyprofile.aSpouseOr') }}</div>
                <div>{{ $t('companyprofile.bAChild') }}</div>
                <div>{{ $t('companyprofile.cAParent') }}</div>
                <div>{{ $t('companyprofile.dABrother') }}</div>
                <br/>
                <div><strong>{{ $t('companyprofile.closeAssociates') }}</strong>{{ $t('companyprofile.includeIndividualsWho') }}</div>
              </b-alert>
            </div>
            <b-form-group label="">
              <b-form-radio-group id="radio-group-pep-enabled" v-model="pep_enabled" name="radio-pep-component" required>
                <b-form-radio name="pep_enabled" value="true">{{ $t('companyprofile.yes2') }}</b-form-radio>
                <b-form-radio name="pep_enabled" value="false">{{ $t('investorprofile.no') }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div v-if="pep_enabled==='true'">
              <b-form-radio-group id="radio-group-pep-type" v-model="form.pep_frontend.type" name="radio-pep-type" required>
                <b-form-radio class="w-100" name="pep_type" value="iam">{{ $t('companyprofile.yesIAm') }}</b-form-radio>
                <b-form-radio class="w-100" name="pep_type" value="family">{{ $t('companyprofile.someOfMy') }}</b-form-radio>
                <b-form-radio class="w-100" name="pep_type" value="close">{{ $t('companyprofile.someOfMy1') }}</b-form-radio>
                <b-form-radio class="w-100" name="pep_type" value="beneficiary">{{ $t('companyprofile.companyBeneficiaryClassifies') }}</b-form-radio>
              </b-form-radio-group>
              <div v-if="form.pep_frontend.type" class="pep-type-form">
                <b-form-group class="form-group">
                  <b-form-input class="form-field"
                                v-model="form.pep_frontend.position"
                                required
                                :placeholder="$t('companyprofile.pleaseSpecifyPosition')"
                                trim
                                :formatter="onlyLatinFormatter"
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="form-group">
                  <b-form-input class="form-field"
                                v-model="form.pep_frontend.organization"
                                required
                                :placeholder="$t('companyprofile.organization')"
                                trim
                                :formatter="onlyLatinFormatter"
                  ></b-form-input>
                </b-form-group>
                <div v-if="form.pep_frontend.type !== 'iam' ">
                  <b-form-group class="form-group">
                    <b-form-input class="form-field"
                                  v-model="form.pep_frontend.relationship"
                                  required
                                  :placeholder="$t('companyprofile.relationship')"
                                  trim
                                  :formatter="onlyLatinFormatter"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <b-form-group class="form-group country-select">
                  <cool-select
                      required
                      v-model="selectedCountry"
                      :items="countryItems"
                      :placeholder="selectedCountry ? '' : $t('app.selectCountry')"
                      item-value="short_name"
                      :item-text="$t('companyprofile.name1')"
                      aria-required="true"
                      ref="country"
                      class="country-select form-field"
                      :class="submitted && !selectedCountry? ' form-control is-invalid': ''"
                  >
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: country }">
                      <div style="display: flex; align-items: center;">
                        <img v-if="country.short_name" :src="getFlag(country.short_name)" class="country-flag">

                        <div>
                          <b>{{ country.name }}</b>
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: country }">
                      <img v-if="country.short_name" :src="getFlag(country.short_name)" class="country-flag">
                      <div>
                        <b>{{ country.name }}</b>
                      </div>
                    </template>
                  </cool-select>
                </b-form-group>
              </div>
            </div>
            <b-form-group>
              <div class="note">{{ $t('companyprofile.pleaseUploadFollowingDocuments') }}</div>
              <label>{{ $t('companyprofile.articlesOfAssociation') }}
                <help-tooltip tooltipText="companyprofile.articlesOfAssociationTooltip"></help-tooltip>
              </label>
              <b-form-file
                  v-if="!articles_file"
                  v-model="form.articles_file"
                  :placeholder="$t('companyprofile.chooseAFile')"
                  :drop-placeholder="$t('companyprofile.dropFileHere')"
                  ref="articles_file"
              ></b-form-file>
              <div>
                <b-badge variant="success" v-if="articles_file">{{ articles_file }}</b-badge>
              </div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('companyprofile.extractFromCompanyRegistry') }}
                <help-tooltip tooltipText="companyprofile.extractFromCompanyRegistryTooltip"></help-tooltip>
              </label>
              <b-form-file
                  v-if="!extract_file"
                  v-model="form.extract_file"
                  :placeholder="$t('companyprofile.chooseAFile1')"
                  :drop-placeholder="$t('companyprofile.dropFileHere1')"
                  ref="extract_file"
              ></b-form-file>
              <div>
                <b-badge variant="success" v-if="extract_file">{{ extract_file }}</b-badge>
              </div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('companyprofile.uboIdentificationDocument') }}
                <help-tooltip tooltipText="companyprofile.uboIdentificationDocumentTooltip"></help-tooltip></label>
              <b-form-file
                  v-if="!ubo_files || ubo_files.length<4"
                  v-model="form.ubo_files"
                  :placeholder="$t('companyprofile.chooseAFilefiles')"
                  :drop-placeholder="$t('companyprofile.dropFilefilesHere')"
                  ref="ubo_files"
                  multiple
              ></b-form-file>
              <div v-if="ubo_files">
                <div v-for="ubo_file in ubo_files" :key="ubo_file">
                  <b-badge variant="success">{{ ubo_file }}</b-badge>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('companyprofile.proofOfAddress') }}
                <help-tooltip tooltipText="companyprofile.proofOfAddressTooltip"></help-tooltip></label>
              <b-form-file
                  v-if="!representative_address_file"
                  v-model="form.representative_address_file"
                  :placeholder="$t('companyprofile.chooseAFile2')"
                  :drop-placeholder="$t('companyprofile.dropFileHere2')"
                  ref="representative_address_file"
              ></b-form-file>
              <div>
                <b-badge variant="success" v-if="representative_address_file">{{ representative_address_file }}</b-badge>
              </div>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox name="agreement" v-model="form.investor_profile_agreement" class="confirm-agreement" required>{{ $t('companyprofile.herebyIConfirm') }}</b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="veriff-section" v-show="pep_enabled==='false' || this.submitted">
        </div>
        <div class="w-100" style="display: inline-block">
          <div class="text-right w-100" style="display: inline-block">
            <b-button type="submit" class="income-btn register-btn" variant="primary" @click="confirmClicked=true">{{ $t('companyprofile.confirm') }}</b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import {CoolSelect} from 'vue-cool-select'
import Error from './Error'
import investor from '@/api/investor'
import flagMixin from '@/mixins/flag'
import Loader from '@/components/Loader'
import imageMixin from '@/mixins/image'
import HelpTooltip from '@/components/HelpTooltip'
import textMixin from '../mixins/text'
import classificatorDataHelper from '@/helpers/classificatorDataHelper'

export default {
  components: {Loader, Error, CoolSelect, HelpTooltip},
  mixins: [flagMixin, imageMixin, textMixin],
  data: () => ({
    submitted: false,
    isFormLoading: false,
    decision_message: 'Person has not been verified.',
    reason_message: 'Not verified',
    errors: [],
    identity_status: 'Not verified',
    confirmClicked: false,
    newUbo: 0,
    pep_enabled: null,
    actual_beneficiary: null,
    pep_help: false,
    selectedCountry: null,
    selectedCitizenship: null,
    form: {
      activity_type: [],
      other_activity_type: '',
      way_power_type: [],
      other_way_power_type: '',
      primary_source: '',
      control_another_person: '',
      origin: '',
      turnover: '',
      pep_frontend: {
        type: '',
        position: '',
        organization: '',
        relationship: '',
        country: ''
      },
      beneficial_owners: [
        {
          first_name: '',
          last_name: '',
          dob: '2000-01-01',
          citizenship: ''
        },
        {
          first_name: '',
          last_name: '',
          dob: '2000-01-01',
          citizenship: ''
        },
        {
          first_name: '',
          last_name: '',
          dob: '2000-01-01',
          citizenship: ''
        },
        {
          first_name: '',
          last_name: '',
          dob: '2000-01-01',
          citizenship: ''
        }
      ],
      extract_file: null,
      articles_file: null,
      representative_address_file: null,
      ubo_files: [],
      investor_profile_agreement: false,
      submitted_confirm: true
    },
    activity_options: [],
    turnover_options: [],
    way_power_options: [],
    primary_source_options: [
      'Active',
      'Passive'
    ],
    countryItems: null,
    citizenshipItems: null,
    extract_file: null,
    articles_file: null,
    representative_address_file: null,
    ubo_files: [],
    bos: [false, false, false, false]
  }),
  mounted()
  {
    this.citizenshipItems = this.countryItems = classificatorDataHelper.getCountriesWithPopularInTop()
    if (this.$store.state.investors.investor)
    {
      this.activity_options = classificatorDataHelper.getGroupItemsAsOptions('COMPANY_ACTIVITY')
      this.primary_source_options = classificatorDataHelper.getGroupItemsAsOptions('COMPANY_MAIN_SOURCE_OF_FUNDS')
      this.turnover_options = classificatorDataHelper.getGroupItemsAsOptions('COMPANY_LAST_12_MONTHS_TURNOVER')
      this.way_power_options = classificatorDataHelper.getGroupItemsAsOptions('COMPANY_WAY_POWER_IS_EXERCISED')
      const investor = this.$store.state.investors.investor
      if (investor.existingInvestorFileList)
      {
        if (investor.existingInvestorFileList.ASSOC_ARTICLE && investor.existingInvestorFileList.ASSOC_ARTICLE[0])
        {
          this.articles_file = investor.existingInvestorFileList.ASSOC_ARTICLE[0]
        }
        if (investor.existingInvestorFileList.REGISTRY_EXTRACT && investor.existingInvestorFileList.REGISTRY_EXTRACT[0])
        {
          this.extract_file = investor.existingInvestorFileList.REGISTRY_EXTRACT[0]
        }
        if (investor.existingInvestorFileList.ID_DOC && investor.existingInvestorFileList.ID_DOC.length)
        {
          this.ubo_files = investor.existingInvestorFileList.ID_DOC
        }
        if (investor.existingInvestorFileList.REPRESENTATIVE_ADDRESS && investor.existingInvestorFileList.REPRESENTATIVE_ADDRESS[0])
        {
          this.representative_address_file = investor.existingInvestorFileList.REPRESENTATIVE_ADDRESS[0]
        }
      }
      if (investor.investor_other_info)
      {
        this.investor_other_info = JSON.parse(investor.investor_other_info)
        // console.log(this.investor_other_info)
        this.form.activity_type = this.investor_other_info.activity_type ? this.investor_other_info.activity_type : this.form.activity_type
        this.form.other_activity_type = this.investor_other_info.other_activity_type ? this.investor_other_info.other_activity_type : this.form.other_activity_type
        this.form.primary_source = this.investor_other_info.primary_source ? this.investor_other_info.primary_source : this.form.primary_source
        this.form.origin = this.investor_other_info.origin ? this.investor_other_info.origin : this.form.origin
        this.form.turnover = this.investor_other_info.turnover ? this.investor_other_info.turnover : this.form.turnover
        this.form.control_another_person = this.investor_other_info.control_another_person ? this.investor_other_info.control_another_person : this.form.control_another_person

        if (this.investor_other_info.beneficial_owners)
        {
          this.actual_beneficiary = 'false'
          for (let i = 0; i < 4; i++)
          {
            if (this.investor_other_info.beneficial_owners[i].first_name)
            {
              this.bos[i] = true
              this.newUbo++
            }
            else
            {
              this.bos[i] = false
            }
            this.form.beneficial_owners[i].first_name = this.investor_other_info.beneficial_owners[i].first_name ? this.investor_other_info.beneficial_owners[i].first_name : this.form.beneficial_owners[i].first_name
            this.form.beneficial_owners[i].last_name = this.investor_other_info.beneficial_owners[i].last_name ? this.investor_other_info.beneficial_owners[i].last_name : this.form.beneficial_owners[i].last_name
            this.form.beneficial_owners[i].dob = this.investor_other_info.beneficial_owners[i].dob ? this.investor_other_info.beneficial_owners[i].dob : this.form.beneficial_owners[i].dob
            this.form.beneficial_owners[i].citizenship = this.investor_other_info.beneficial_owners[i].citizenship ? this.investor_other_info.beneficial_owners[i].citizenship : this.form.beneficial_owners[i].citizenship
            if (this.investor_other_info.beneficial_owners[i + 1] && !this.investor_other_info.beneficial_owners[i + 1].first_name)
            {
              // this.newUbo++
            }
          }
        }
        this.form.way_power_type = this.investor_other_info.way_power_type ? this.investor_other_info.way_power_type : this.form.way_power_type
        this.form.other_way_power_type = this.investor_other_info.other_way_power_type ? this.investor_other_info.other_way_power_type : this.form.other_way_power_type
        this.form.investor_profile_agreement = this.investor_other_info.investor_profile_agreement
      }
      if (investor.investor_pep_frontend_content)
      {
        this.investor_pep_frontend_content = JSON.parse(investor.investor_pep_frontend_content)
        // console.log(this.investor_pep_frontend_content)
        if (this.investor_pep_frontend_content.type)
        {
          this.pep_enabled = 'true'
          this.form.pep_frontend.type = this.investor_pep_frontend_content.type ? this.investor_pep_frontend_content.type : this.form.pep_frontend.type
          this.selectedCountry = this.investor_pep_frontend_content.country ? this.investor_pep_frontend_content.country : this.selectedCountry
          this.form.pep_frontend.organization = this.investor_pep_frontend_content.organization ? this.investor_pep_frontend_content.organization : this.form.pep_frontend.organization
          this.form.pep_frontend.position = this.investor_pep_frontend_content.position ? this.investor_pep_frontend_content.position : this.form.pep_frontend.position
          this.form.pep_frontend.relationship = this.investor_pep_frontend_content.relationship ? this.investor_pep_frontend_content.relationship : this.form.pep_frontend.relationship
        }
        else
        {
          this.pep_enabled = 'false'
        }
      }
    }
  },
  watch: {
    selectedCountry: function (selected)
    {
      this.form.pep_frontend.country = selected
    },
    'form.activity_type': function (val)
    {
      if (val.length > 0)
      {
        this.$refs.activity_type.$el.classList.remove('invalid', 'is-invalid')
      }
      else
      {
        this.$refs.activity_type.$el.classList.add('invalid', 'is-invalid')
      }
    },
    actual_beneficiary: function (value)
    {
      if (value === 'false' && this.bos.filter(e => e === true).length === 0)
      {
        this.addAnotherUbo()
      }
    }
  },
  methods: {
    onSubmit(evt)
    {
      evt.preventDefault()
      if (this.form.activity_type.length < 1)
      {
        this.$refs.activity_type.$el.classList.add('invalid', 'is-invalid')
        this.$refs.activity_type.$el.focus()
        this.errors.push('Choose one of activity type, please!')
        return false
      }
      if (this.pep_enabled === 'true')
      {
        if (!this.form.pep_frontend.country)
        {
          this.$refs.country.$el.classList.add('form-control', 'is-invalid')
          return false
        }
        else
        {
          this.$refs.country.$el.classList.remove('form-control', 'is-invalid')
        }
      }
      else
      {
        this.form.pep_frontend = false
      }
      if (this.actual_beneficiary === true || this.bos.filter(x => x === true).length === 0)
      {
        this.form.beneficial_owners = false
      }
      this.isFormLoading = true
      this.$emit('updateinvestor', this.form)
      investor.update(this.form).then((response) =>
          {
            if (this.form.articles_file || this.form.extract_file || this.form.ubo_files.length > 0 || this.form.representative_address_file)
            {
              const formData = new FormData()

              if (this.form.articles_file)
              {
                formData.append('ASSOC_ARTICLE', this.form.articles_file)
              }
              if (this.form.extract_file)
              {
                formData.append('REGISTRY_EXTRACT', this.form.extract_file)
              }

              this.form.ubo_files.forEach((file, i) =>
              {
                formData.append('ID_DOC[' + i + ']', file)
              })

              if (this.form.representative_address_file)
              {
                formData.append('REPRESENTATIVE_ADDRESS', this.form.representative_address_file)
              }

              const axios = require('axios').default
              axios.post('/upload-profile-files',
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
              ).then(() =>
              {
                if (response)
                {
                  // this.$store.state.investors.investor.investor_account_status = investorStatuses.PROFILE_FILLED
                  // console.log('Set response.investor_account_status:', response.investor_account_status)
                  this.$store.state.investors.investor.investor_account_status = response.investor_account_status
                  this.$store.state.investors.investor.problems = response.problems
                  this.$emit('setstep', 3)
                  this.submitted = true
                  window.scrollTo(0, 0) // for mobile devices
                }
              })
                  .catch((error) =>
                  {
                    this.errors.push(error)
                    this.submitted = false
                  })
            }
            else
            {
              if (response)
              {
                // this.$store.state.investors.investor.investor_account_status = investorStatuses.PROFILE_FILLED
                // console.log('Set response.investor_account_status:', response.investor_account_status)
                this.$store.state.investors.investor.investor_account_status = response.investor_account_status
                this.$store.state.investors.investor.problems = response.problems
                this.$emit('setstep', 3)
                this.submitted = true
                window.scrollTo(0, 0) // for mobile devices
              }
            }
          }
      ).catch((error) =>
      {
        this.errors.push(error)
        this.submitted = false
      }).then(() =>
          {
            this.isFormLoading = false
            window.scrollTo(0, 0) // for mobile devices
          }
      )
    },
    dateDisabled(ymd, date)
    {
      const now = new Date()
      const year = date.getFullYear() + 18
      return year > now.getFullYear()
    },
    removeUboPerson(index)
    {
      this.bos[index] = false
      this.form.beneficial_owners[index].first_name = ''
      this.form.beneficial_owners[index].last_name = ''
      this.form.beneficial_owners[index].dob = '2000-01-01'
      this.form.beneficial_owners[index].citizenship = ''
      this.newUbo--
      if (this.bos.filter(x => x === true).length === 0)
      {
        this.actual_beneficiary = 'true'
      }
    },
    addAnotherUbo()
    {
      this.newUbo++
      for (let i = 0; i < this.bos.length; i++)
      {
        if (this.bos[i] === false)
        {
          this.bos[i] = true
          break
        }
      }
    },
    translate(options)
    {
      return options.map(el =>
          {
            if (el.label_i18n)
            {
              el.text = this.$t(el.label_i18n)
            }
            return el
          }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.pep-section {
  display: inline-block;
  margin-top: 15px;
  margin-bottom: 2px;
  width: 100%;
}

.pep-type-form {
  display: inline-block;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 2px;
}

.help {
  width: 18px;
  margin-top: -4px;
  cursor: pointer;
}

.according {
  margin-top: 5px;
  margin-bottom: 5px;
}

.invalid {
  border: 1px solid red;
  border-radius: 5px;
  padding: 2px;
}

.note {
  margin-bottom: 15px;
  margin-top: 10px;
}
</style>
